<template>
  <div>
    <loading-data v-if="loadData" />
    <div v-else class="card">
      <div class="card-header bg-transparent border-bottom">
        <h5 class="card-title mb-0">Detalhes do Cliente</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4 col-sm-6">
            <p><strong>Nome:</strong> {{ client.name }}</p>
          </div>
          <div class="col-md-4 col-sm-6">
            <p><strong>CPF/CNPJ:</strong> {{ client.cpfcnpj }}</p>
          </div>
          <div class="col-md-4 col-sm-6">
            <p><strong>Telefone:</strong> {{ client.telefone }}</p>
          </div>
          <div class="col-md-4 col-sm-6">
            <p><strong>E-mail:</strong> {{ client.email }}</p>
          </div>
          <div class="col-md-4 col-sm-6">
            <p>
              <strong>Cidade/Estado:</strong> {{ client.city }}/{{ client.uf }}
            </p>
          </div>
          <div class="col-md-4 col-sm-6">
            <p>
              <strong>Status: </strong>
              <span v-html="statusTranslate(client.status)" />
            </p>
          </div>
          <div class="col-md-4 col-sm-6">
            <p>
              <strong>Criado por:</strong>
              {{ createdUpdatedUser(client.createdBy, client.createdAt) }}
            </p>
          </div>
          <div class="col-md-4 col-sm-6">
            <p>
              <strong>Atualizado por:</strong>
              {{ createdUpdatedUser(client.updatedBy, client.updatedAt) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createdUpdatedUser, statusTranslate } from '@/utils/strings'
import LoadingData from '@/components/commons/LoadingData.vue'

export default {
  name: 'DetailsClient',

  components: {
    LoadingData,
  },

  props: {
    clientId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      client: {},
      createdUpdatedUser,
      statusTranslate,
    }
  },

  methods: {
    async getClient() {
      try {
        this.client = await this.$store.dispatch('getClient', this.clientId)
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
      }
    },
  },

  mounted() {
    this.getClient()
  },
}
</script>
